import { Pipe, PipeTransform } from '@angular/core';
import { DateUtilsService } from '../services/date-utils.service';

@Pipe({
  name: 'utcDate'
})
export class UtcDatePipe implements PipeTransform {
  constructor(private dateUtils: DateUtilsService) {}
  
  transform(value: any, format: string = 'dd/MM/yyyy'): string {
    return this.dateUtils.formatDateToLocal(value, format);
  }
}
